module.exports = "<hybse-admin-add-market [isDemo]=\"true\"></hybse-admin-add-market>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/demo-company/demo-markets/create-demo-markets/create-demo-markets.component.html
// module id = ../../../../../src/app/components/pages/demo-company/demo-markets/create-demo-markets/create-demo-markets.component.html
// module chunks = main